import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cdfce993-612e-4617-ac7b-89da32b19bd7/artifacts/wcwsdulx_Logo%20benchory.png';

export function LegalLayout({ title, subtitle, date, children }) {
  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif", color: '#1a1a1a', minHeight: '100vh', background: '#FAF8F5' }}>
      {/* Navbar */}
      <nav style={{ background: '#111622', padding: '0 48px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
          <img src={LOGO_URL} alt="BENCHORY" style={{ height: 28, objectFit: 'contain' }} />
        </Link>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', color: 'rgba(244,239,230,0.5)', fontSize: 13, fontWeight: 500, transition: 'color 0.2s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#D4A85C'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(244,239,230,0.5)'}
        >
          <ArrowLeft size={16} />
          Retour
        </Link>
      </nav>

      {/* Header */}
      <header style={{ background: '#111622', padding: '48px 48px 56px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <span style={{ width: 28, height: 1, background: '#B8924A', opacity: 0.5, display: 'inline-block' }} />
            <span style={{ fontSize: 9, letterSpacing: 5, textTransform: 'uppercase', color: '#B8924A' }}>Document juridique</span>
          </div>
          <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 32, fontWeight: 400, color: '#FAF8F5', marginBottom: 8, lineHeight: 1.3 }}>{title}</h1>
          {subtitle && <p style={{ fontSize: 14, color: 'rgba(244,239,230,0.5)', fontWeight: 300, marginBottom: 4 }}>{subtitle}</p>}
          <p style={{ fontSize: 12, color: 'rgba(244,239,230,0.25)', fontWeight: 300 }}>{date}</p>
        </div>
      </header>

      {/* Content */}
      <main style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>
        <div className="legal-content" style={{ fontSize: 14, lineHeight: 1.85, color: '#333' }}>
          {children}
        </div>
      </main>

      {/* Footer links */}
      <footer style={{ background: '#181E2C', padding: '40px 48px', display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
        {[
          { label: 'Mentions légales', to: '/mentions-legales' },
          { label: 'CGU', to: '/cgu' },
          { label: 'CGV', to: '/cgv' },
          { label: 'Confidentialité', to: '/confidentialite' },
        ].map(l => (
          <Link key={l.to} to={l.to} style={{ fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(244,239,230,0.2)', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#B8924A'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(244,239,230,0.2)'}
          >{l.label}</Link>
        ))}
      </footer>
    </div>
  );
}

/* Reusable heading styles for legal articles */
export function Article({ num, title, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 20, fontWeight: 400, color: '#111622', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #E8E0D4' }}>
        {num && <span style={{ color: '#B8924A', marginRight: 8 }}>{num} —</span>}{title}
      </h2>
      <div style={{ paddingLeft: 0 }}>{children}</div>
    </section>
  );
}

export function SubArticle({ num, title, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <h3 style={{ fontSize: 15, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>
        {num && <span style={{ color: '#B8924A', marginRight: 6 }}>{num}</span>}{title}
      </h3>
      <div>{children}</div>
    </div>
  );
}

export function P({ children }) {
  return <p style={{ marginBottom: 12 }}>{children}</p>;
}

export function Dash({ children }) {
  return <div style={{ paddingLeft: 16, marginBottom: 4, position: 'relative' }}>
    <span style={{ position: 'absolute', left: 0, color: '#B8924A' }}>—</span>
    <span>{children}</span>
  </div>;
}
